import * as React from 'react';
import Divider from '@mui/material/Divider';
import Drawer, { DrawerProps } from '@mui/material/Drawer';
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import HomeIcon from '@mui/icons-material/Home';
import PeopleIcon from '@mui/icons-material/People';
import SensorDoorIcon from '@mui/icons-material/SensorDoor';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import SettingsIcon from '@mui/icons-material/Settings';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';

import Logo from '../images/logo-only.png';
import { useLocation, useNavigate } from 'react-router-dom';
import i18next from 'i18next';


const item = {
    py: '2px',
    px: 3,
    color: 'rgba(255, 255, 255, 0.7)',
    '&:hover, &:focus': {
        bgcolor: 'rgba(255, 255, 255, 0.08)',
    },
};

const itemCategory = {
    boxShadow: '0 -1px 0 rgb(255,255,255,0.1) inset',
    py: 1.5,
    px: 3,
};

export default function Navigator(props: DrawerProps) {
    const { ...other } = props;
    const navigate = useNavigate();
    const location = useLocation();

    const categories = [
        {
            id: 'access',
            label: i18next.t("Navigator.access"),
            children: [
                { id: 'cards', label: i18next.t("Navigator.cards"), icon: <CreditCardIcon />, path: '/cards' },
                /*{ id: 'users', label: i18next.t("Navigator.users"), icon: <PeopleIcon />, path: '/users' },*/
                { id: 'Portes et barrières', label: i18next.t("Navigator.gate"), icon: <SensorDoorIcon />, path: '/gates' },
            ],
        },
        {
            id: 'admin',
            label: i18next.t("Navigator.admin"),
            children: [
                /*{ id: 'Configurations', label: i18next.t("Navigator.configurations"), icon: <SettingsIcon />, path: '/configurations' },*/
                { id: 'Historique', label: i18next.t("Navigator.history"), icon: <ManageSearchIcon />, path: '/history' },
            ],
        }
    ];

    return (
        <Drawer variant="permanent" {...other}>
            <List disablePadding>
                <ListItem sx={{ ...item, ...itemCategory, fontSize: 22, color: '#fff' }}>
                    <img style={{ height: 80, color: 'white' }} src={Logo} alt="this is car image" />
                </ListItem>
                <ListItem sx={{ ...item, ...itemCategory }}>
                    <ListItemIcon>
                        <HomeIcon />
                    </ListItemIcon>
                    <ListItemText>{i18next.t("Navigator.mysite")}</ListItemText>
                </ListItem>
                {categories.map(({ id, label, children }) => (
                    <Box key={id} sx={{ bgcolor: '#1D2833' }}>
                        <ListItem sx={{ py: 2, px: 3 }}>
                            <ListItemText sx={{ color: '#fff' }}>{label}</ListItemText>
                        </ListItem>
                        {children.map(({ id: childId, label: childLabel, icon, path }) => (
                            <ListItem disablePadding key={childId}>
                                <ListItemButton selected={location.pathname.includes(path ? path : '')} sx={item} onClick={() => { if (path) navigate(path); }}>
                                    <ListItemIcon>{icon}</ListItemIcon>
                                    <ListItemText>{childLabel}</ListItemText>
                                </ListItemButton>
                            </ListItem>
                        ))}
                        <Divider sx={{ mt: 2 }} />
                    </Box>
                ))}
            </List>
        </Drawer >
    );
}